export default __webpack_public_path__ + "static/media/Vinos1000.ef368cb1.png";